export const LEGAL_NOTICE_HEADING = "legal-notice-heading";
export const LEGAL_NOTICE_TEXT_ONE = "legal-notice-text-one";
export const LEGAL_NOTICE_TEXT_TWO = "legal-notice-text-two";
export const LEGAL_NOTICE_TEXT_THREE = "legal-notice-text-three";
export const LEGAL_NOTICE_BUTTON = "timeout-warning-modal-continue-btn";
export const LEGAL_NOTICE_BUTTON_ID = "legal-notice-continue-button";
